import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card } from '@/components/ui/card';
import { useNavigate } from 'react-router-dom';

export default function AgeGate() {
  const [age, setAge] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!name.trim()) {
      setError('Please enter your name');
      return;
    }

    const ageNum = parseInt(age);
    if (!age || isNaN(ageNum)) {
      setError('Please enter your age');
      return;
    }

    if (ageNum < 8) {
      setError('You must be 8 or older to play');
      return;
    }

    localStorage.setItem('playerName', name);
    localStorage.setItem('playerAge', age);
    navigate('/modes');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-400 via-purple-400 to-pink-400 flex items-center justify-center p-4">
      <Card className="w-full max-w-md p-8 bg-white/95 backdrop-blur shadow-2xl">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-purple-600 mb-2">
            Kids Talking
          </h1>
          <p className="text-gray-600">Chat with amazing AI characters!</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              What's your name?
            </label>
            <Input
              type="text"
              placeholder="Enter your name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="text-lg"
            />
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              How old are you?
            </label>
            <Input
              type="number"
              placeholder="Enter your age"
              value={age}
              onChange={(e) => setAge(e.target.value)}
              min="8"
              max="120"
              className="text-lg"
            />
          </div>

          {error && <p className="text-red-500 text-sm font-semibold">{error}</p>}

          <Button
            type="submit"
            className="w-full bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600 text-white font-bold text-lg py-6 rounded-lg"
          >
            Let's Play!
          </Button>
        </form>

        <p className="text-center text-xs text-gray-500 mt-6">
          By playing, you agree to keep conversations safe and friendly.
        </p>
      </Card>
    </div>
  );
}
